// ** React Imports
import { ReactNode } from 'react'

// ** MUI Components
import Box, { BoxProps } from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { styled, useTheme } from '@mui/material/styles'

// ** Layout Import
import BlankLayout from 'src/@core/layouts/BlankLayout'

// ** Hooks
import { useSettings } from 'src/@core/hooks/useSettings'

// ** Demo Components Imports
import RegisterMultiStepsWizard from 'src/views/pages/auth/register-multi-steps'

// ** Styled Components
const RegisterMultiStepsIllustration = styled('img')({
    height: 'auto',
    maxHeight: 650,
    maxWidth: '100%'
})

const LeftWrapper = styled(Box)<BoxProps>(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(12, 0, 12, 12),
    [theme.breakpoints.up('lg')]: {
        maxWidth: 480
    },
    [theme.breakpoints.down(1285)]: {
        maxWidth: 400
    },
    [theme.breakpoints.up('xl')]: {
        maxWidth: 725
    }
}))

const RightWrapper = styled(Box)<BoxProps>(({ theme }) => ({
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6),
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(12)
    }
}))

const WizardWrapper = styled(Box)<BoxProps>(({ theme }) => ({
    maxWidth: 650,
    margin: theme.spacing(0, 'auto'),
    [theme.breakpoints.up('md')]: {
        width: 650
    }
}))

const RegisterMultiSteps = () => {
    // ** Hooks
    const theme = useTheme()
    const { settings } = useSettings()
    const hidden = useMediaQuery(theme.breakpoints.down('lg'))

    // ** Var
    const { skin } = settings

    return (
        <Box sx={{display: 'flex', minHeight: '100vh', overflowX: 'hidden', position: 'relative'}}>
            {!hidden ? (
                <LeftWrapper>
                    <RegisterMultiStepsIllustration
                        alt='register-multi-steps-illustration'
                        src='/images/pages/auth-v2-register-multi-steps-illustration.png'
                    />
                </LeftWrapper>
            ) : null}
            <RightWrapper sx={skin === 'bordered' && !hidden ? { borderLeft: `1px solid ${theme.palette.divider}` } : {}}>
                <WizardWrapper>
                    <RegisterMultiStepsWizard />
                </WizardWrapper>
            </RightWrapper>
        </Box>
    )
}

RegisterMultiSteps.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>

export default RegisterMultiSteps
